module.exports = __webpack_public_path__ + "static/img/30.87a5549.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/30.png
// module id = 1G51
// module chunks = 0